import React, { useContext, useMemo } from "react";
import clsx from "clsx";

import { Context } from "../../../../teacherStore";
import { getStudentAnswersByQuestion } from "../../../../libs/ActiveLearning";
import styles from "../ActiveLearningLessonAnswerData.module.scss";

interface ILesson12Pros {
  materialCode: string;
  lessonNo: number;
}

export const Lesson12: React.FC<ILesson12Pros> = ({
  materialCode,
  lessonNo,
}) => {
  const { state } = useContext(Context);
  const activeLearningStudentAnswers = state.active_learning_student_answers;

  const answersL2I1Q1 = useMemo(() => {
    const answers = getStudentAnswersByQuestion(
      materialCode,
      activeLearningStudentAnswers,
      lessonNo,
      1,
      1,
    );

    return answers.length > 0
      ? answers.map(answer => answer.contents.value).join("")
      : "回答データがありません。";
  }, [materialCode, activeLearningStudentAnswers, lessonNo]);

  const answersL2I2Q1 = useMemo(() => {
    return getStudentAnswersByQuestion(
      materialCode,
      activeLearningStudentAnswers,
      lessonNo,
      2,
      1,
    );
  }, [materialCode, activeLearningStudentAnswers, lessonNo]);

  const answersL2I3Q1 = useMemo(() => {
    const answers = getStudentAnswersByQuestion(
      materialCode,
      activeLearningStudentAnswers,
      lessonNo,
      3,
      1,
    );

    return answers.length > 0
      ? answers.map(answer => answer.contents.value).join("")
      : "回答データがありません。";
  }, [materialCode, activeLearningStudentAnswers, lessonNo]);

  return (
    <div className={styles.lesson}>
      <p className={styles.title}>
        Lesson{lessonNo < 10 ? `0${lessonNo}` : lessonNo}{" "}
        自分がワクワクする「問い」を見つけよう
      </p>
      <div className={styles.inner}>
        <div className={styles.work}>
          <p className={styles.no}>WORK01</p>
          <p className={styles.heading}>
            企業の事例を見て具体的にテーマをイメージしよう。
          </p>
          <div className={styles.question}>
            <p className={clsx(styles.heading, styles.dot)}>
              動画を見て感じたことを入力しよう。
            </p>
            <p className={clsx(styles.answer, styles.high)}>{answersL2I1Q1}</p>
          </div>
        </div>
        <div className={styles.work}>
          <p className={styles.no}>WORK02</p>
          <div className={styles.question}>
            <p className={styles.heading}>
              色々な企業の取り組みを調べ、その取り組みが生み出している価値について考えよう。
            </p>
            <div className={styles.tableWrapper}>
              <table className={clsx(styles.table, styles.company)}>
                <thead>
                  <tr>
                    <th className={styles.name}>企業名</th>
                    <th className={styles.value}>取り組み/届けている価値</th>
                    <th className={styles.reason}>取り上げた理由</th>
                  </tr>
                </thead>
                <tbody>
                  {answersL2I2Q1.length > 0 ? (
                    answersL2I2Q1.map(answer => (
                      <tr key={answer.id}>
                        <td className={clsx(styles.textInput, styles.name)}>
                          {answer.contents.interest}
                        </td>
                        <td className={clsx(styles.textInput, styles.value)}>
                          {answer.contents.reason}
                        </td>
                        <td className={clsx(styles.textInput, styles.reason)}>
                          {answer.contents.activity}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td className={clsx(styles.textInput, styles.name)}>
                        回答データがありません。
                      </td>
                      <td className={clsx(styles.textInput, styles.value)}>
                        回答データがありません。
                      </td>
                      <td className={clsx(styles.textInput, styles.reason)}>
                        回答データがありません。
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className={styles.work}>
          <p className={styles.no}>WORK03</p>
          <div className={styles.question}>
            <p className={styles.heading}>
              どんな価値を届けたいかを意識して、自分だけのワクワクできる「問い」を考えよう。
            </p>
            <p className={styles.answer}>{answersL2I3Q1}</p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Lesson12;
